
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { allUpdateStopReason, getStopReasonPage } from "@/api/api-basic";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class PiAllConfigReason extends Vue {
  @Prop({
    default: () => {
      return [];
    }
  })
  private responsibilityTypeList!: object[];
  private modalShow = false;
  private modalTitle = i18n.t("stopReason.allConfig");
  private formInline: objAny = {
    responsibilityType: "",
    stopCode: "",
    stopName: ""
  };
  private loading = false;
  private loadingTable = false;
  private gradeList: object[] = [];
  private selectList: object[] = [];
  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      type: "selection",
      width: 60,
      align: "center"
    },
    {
      title: i18n.t("stopReason.stopCode"),
      key: "stopCode",
      minWidth: 120
    },
    {
      title: i18n.t("stopReason.stopName"),
      key: "stopName",
      minWidth: 120
    }
  ];
  private formInlineTable: objAny = {
    globalPageIndex: 1,
    globalPageSize: 10
  };
  private total = 0;
  private ruleInline: objAny = {
    responsibilityType: [
      {
        required: true,
        message: i18n.t("stopReason.responsibilityTypePl"),
        trigger: "change"
        // type: "number"
      }
    ]
  };
  private formObj: objAny = {};

  public open() {
    this.modalShow = true;
    if (this.tableList.length == 0) {
      this.queryClick();
    }
    this.$nextTick(() => {
      this.formObj = this.$refs["formInline"];
    });
  }
  public selectItem(list: object[]) {
    this.selectList = list;
  }
  public queryClick() {
    this.formInlineTable.globalPageIndex = 1;
    this.getTableList();
  }
  public tableChange(val: number) {
    this.formInlineTable.globalPageIndex = val;
    this.getTableList();
  }
  public tableSizeChange(val: number) {
    this.formInlineTable.globalPageSize = val;
    this.getTableList();
  }

  async getTableList(): Promise<void> {
    this.loadingTable = true;
    const ret = await getStopReasonPage(this.formInline);
    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      this.tableList = ret.data;
    }
    this.selectList = [];
    this.loadingTable = false;
  }

  public closeModel() {
    this.modalShow = false;
  }

  public handleSubmit() {
    this.formObj.validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      }
    });
  }
  async submitData() {
    const stopCodes: string[] = [];
    this.selectList.map((item: objAny) => {
      stopCodes.push(item.stopCode);
    });
    if (stopCodes.length == 0) {
      this.$Message.error(i18n.t("stopReason.configDataPl"));
      return;
    }

    const ret = await allUpdateStopReason({
      responsibilityType: this.formInline.responsibilityType,
      stopCodes: stopCodes
    });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("stopReason.configSuccess"));
      this.$emit("success");
      this.closeModel();
    }
  }
}
